/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Name_PlaceholderInputs */

const en_common_sign_name_placeholder = /** @type {(inputs: Common_Sign_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

const zh_common_sign_name_placeholder = /** @type {(inputs: Common_Sign_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入姓名`)
};

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Common_Sign_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_name_placeholder = /** @type {((inputs?: Common_Sign_Name_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Name_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_name_placeholder(inputs)
	return zh_common_sign_name_placeholder(inputs)
});
export { common_sign_name_placeholder as "common.sign.name_placeholder" }